import graphql from "babel-plugin-relay/macro";

export default graphql`
  query getApprovalRequestsQuery($orgId: ID!, $type: String, $propertyId: ID) {
    approvalRequests(orgId: $orgId, type: $type, propertyId: $propertyId) {
      edges {
        node {
          id
          propertyId
          approvedAt
          approverEmails
          propertyName
          hyevent {
            id
            title
            status
            propertyId
            publishAt
          }
          createdAt
        }
      }
    }
  }
`;